/**
 * @class Model
 * @classdesc Handles creating an model element
 */
 export default class Model {
  constructor(el) {
    const features = [
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => this._onLibraryLoad(),
      },
      {
        name: 'shopify-xr',
        version: '1.0',
      },
    ];

    this.el = el;
    this._onCorePauseMedia = (event) => {
      const { exclude } = event.detail;
      let shouldPause = true;

      if (Array.isArray(exclude) && exclude.some(e => e === el)) {
        shouldPause = false;
      } else if (exclude === el) {
        shouldPause = false;
      }

      if (shouldPause) {
        this.pause();
      }
    }

    window.Shopify.loadFeatures(features);
    document.body.addEventListener('core:pause-media', this._onCorePauseMedia);
  }

  /**
   * Play the media
   * @public
   */
  play() {
    if (this._model) {
      this._model.play();
    }
  }

  /**
   * Pause the media
   * @public
   */
  pause() {
    if (this._model) {
      this._model.pause();
    }
  }

  unload() {
    if (this._model) {
      this._model.destroy();
    }

    document.body.removeEventListener('core:pause-media', this._onCorePauseMedia);
  }

  /**
   * On Shopify XR library load, create a new model UI
   */
  _onLibraryLoad() {
    const controls = ['zoom-in', 'zoom-out'];
    if (document.fullscreenEnabled) controls.push('fullscreen');

    this._model = new Shopify.ModelViewerUI(this.el, { controls });
  }
}
